<ng-container *ngIf="membership.unlinked_customers.length > 0">
  <div class="alert alert-info">
    This membership has outstanding unlinked members. Link those members before modifying the membership.
  </div>
</ng-container>

<ng-container *ngIf="membership.unlinked_customers.length === 0">
  <div class="alert alert-info">
    The chosen member will be added on the next bill date. The membership's price will be updated at that time to reflect the new set of members.
  </div>

  <button class="btn btn-sm btn-outline-primary"
          type="button"
          (click)="openSelectCustomerModal()">
    Select Customer to Add
  </button>

  <p *ngIf="selectedCustomer" class="mb-0 mt-3">
    Selected Customer:
    <b>{{ selectedCustomer.first_name }} {{ selectedCustomer.last_name }}</b>
  </p>
</ng-container>

<div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
